export default __webpack_public_path__ + "static/media/Opportunity.f1bca2da.svg";